import { render, staticRenderFns } from "./CalendarDashboardStats.vue?vue&type=template&id=64b726a6"
import script from "./CalendarDashboardStats.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports